import { css } from 'styled-components';
import {
  Author,
  AuthorJobDescription,
} from '../../../../../components/TestimonialWithImage/TestimonialQuote/styles';
import { themeSpecificColors } from '../../../colors';
import { fontWeightMedium } from '../../../fonts';

export default css`
  ${Author} {
    font-weight: ${fontWeightMedium};
  }
  ${AuthorJobDescription} {
    color: ${themeSpecificColors.core04_40};
  }
`;
